import { CreateOnCallRequest } from '~/domain/usecases/onCallRequest/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  Conflict,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteCreateOnCallRequest implements CreateOnCallRequest {
  private readonly url: string;

  private readonly httpClient: HttpClient<CreateOnCallRequest.Model>;

  constructor(url: string, httClient: HttpClient<CreateOnCallRequest.Model>) {
    this.url = url;
    this.httpClient = httClient;
  }

  create = async (
    params: CreateOnCallRequest.Params,
  ): Promise<CreateOnCallRequest.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      body: params,
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.created:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.forbidden:
        throw new Forbidden();
      case HttpStatusCode.conflict:
        throw new Conflict();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      default:
        throw new UnexpectedError();
    }
  };
}
